import style from './ProjectCreate.module.css';
import { useState, useMemo } from 'react';

import { uploadFile } from '../../../api/filesApi';
import { createPost } from '../../../api/postsApi';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { createProject } from '../../../api/projectsApi';

const ProjectCreate = ({}) => {
  const [files, setFiles] = useState([]);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: '',
    description: '',
    websiteUrl: '',

    imageUrl: '',
  });

  const [touched, setTouched] = useState({});

  const errors = useMemo(() => {
    const e = {};
    if (!form.title.trim()) e.title = 'Title is required ';
    if (!form.description.trim()) e.description = 'Text is required';
    if (files[0]) {
      e.imageUrl = 'Посилання має починатися з http(s)://';
    }
    return e;
  }, [form]);

  const handleChangeFile = e => {
    setFiles([...e.target.files]);
  };

  const isValid = Object.keys(errors).length === 0;

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(s => ({ ...s, [name]: value }));
  };

  const handleBlur = e => {
    const { name } = e.target;
    setTouched(t => ({ ...t, [name]: true }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    // позначити всі як торкнуті, щоб показати помилки
    setTouched({
      title: true,
      description: true,
      websiteUrl: true,

      imageUrl: true,
    });
    if (!isValid) return;

    const file = files[0];
    const imageUrl = await uploadFile(file);

    const result = {
      title: form.title.trim(),
      description: form.description.trim(),
      websiteUrl: form.websiteUrl.trim(), // залишаємо як рядок; за потреби можна split(',')

      imageUrl: imageUrl,
    };

    if (typeof onCreate === 'function') {
      onCreate(result);
    } else {
      const promise = createProject(result);
      toast
        .promise(promise, {
          loading: 'Wait. Project is creating',
          success: 'Project has been created',
          error: 'Ups. Something went wrong',
        })
        .then(() => {
          navigate('/admin/projects');
        });
    }

    // опціонально очищаємо форму
    // setForm({ title: "", description: "", websiteUrl: "", mainText: "", imageUrl: "" });
  };

  const CharCounter = ({ value, max }) => (
    <span className={style.counter} aria-live="polite">
      {value.length}
      {typeof max === 'number' ? `/${max}` : ''}
    </span>
  );

  return (
    <div className={style.wrapper}>
      <form className={style.form} onSubmit={handleSubmit} noValidate>
        <h2 className={style.title}>Create project</h2>

        {/* Title */}
        <div className={style.group}>
          <label className={style.label} htmlFor="title">
            Title *
          </label>
          <input
            id="title"
            name="title"
            type="text"
            className={style.input}
            placeholder="Title"
            value={form.title}
            onChange={handleChange}
            onBlur={handleBlur}
            required
          />
          <div className={style.metaRow}>
            <CharCounter value={form.title} max={120} />
            {touched.title && errors.title && (
              <span className={style.error}>{errors.title}</span>
            )}
          </div>
        </div>

        {/* Description */}
        <div className={style.group}>
          <label className={style.label} htmlFor="description">
            Description
          </label>
          <textarea
            id="description"
            name="description"
            className={style.textarea}
            placeholder="Description"
            value={form.description}
            onChange={handleChange}
            onBlur={handleBlur}
            rows={3}
          />
          <div className={style.metaRow}>
            <CharCounter value={form.description} max={300} />
          </div>
        </div>

        {/* websiteUrl */}
        <div className={style.group}>
          <label className={style.label} htmlFor="websiteUrl">
            Website url
          </label>
          <input
            id="websiteUrl"
            name="websiteUrl"
            type="text"
            className={style.input}
            placeholder="website url"
            value={form.websiteUrl}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        {/* Image URL */}
        <div className={style.group}>
          <label className={style.label} htmlFor="imageUrl">
            Upload Image
          </label>
          <input
            id="imageUrl"
            name="imageUrl"
            type="file"
            className={style.input}
            onChange={handleChangeFile}
            onBlur={handleBlur}
          />
        </div>

        <div className={style.actions}>
          <button type="submit" className={style.submitBtn} disabled={!isValid}>
            Create Project
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProjectCreate;
